module.exports = __webpack_public_path__ + "static/logo-e7692acfadfd4f2b383f10f864e4709b.png";